<ng-container *adaptLoadingUntilFirstEmit="let person of person$">
    <adapt-toolbar-inactive [entity]="person"
                            type="account"> </adapt-toolbar-inactive>

    @if (person) {
        <div adaptToolbarContent>
            @if (canEditSomethingOnPage$ | async) {
                @if (isEditing) {
                    <button adaptButton="view"
                            data-test="view-mode-button"
                            (click)="setViewMode()"></button>
                }
                @if (!isEditing) {
                    <button adaptButton="edit"
                            data-test="edit-mode-button"
                            (click)="setEditMode()"></button>
                }
            }
            @if (accountSecurityRoute$ | async; as accountSecurityRoute) {
                <a *adaptIfAuthorised="ChangePasswordForPerson; entity: person"
                   class="btn btn-link"
                   adaptButtonIcon="fal fa-key"
                   adaptTooltip="You can update your login email, change your password, and configure single sign-on (SSO) here"
                   tooltipPlacement="bottom-left"
                   [routerLink]="accountSecurityRoute.path"
                   [queryParams]="accountSecurityRoute.queryParams"
                   data-test="account-security-button">Account security</a>
            }
            <ng-container *adaptIfAuthorised="ManagePositionAndRoles; entity: person">
                <adapt-user-role-actions [connection]="latestConnection$ | async"
                                         (connectionChanged)="triggerConnectionUpdate($event)"></adapt-user-role-actions>
            </ng-container>
        </div>
    }

    @if (person) {
        <adapt-two-column-page>
            <div left-column>
                <adapt-dashboard-element>
                    <div adapt-dashboard-title-buttons>
                        @if (isEditing) {
                            <button adaptButton="editBorderless"
                                    (click)="editName()"></button>
                        }
                    </div>
                    <div adapt-dashboard-title
                         class="profile-header pt-3">
                        @if (!isEditing && !person.imageIdentifier) {
                            <adapt-person-default-image class="me-3"
                                                        imageSize="lg"
                                                        [person]="person"></adapt-person-default-image>
                        }
                        @if (person.imageIdentifier || isEditing) {
                            <adapt-select-image [imageIdentifier]="person.imageIdentifier"
                                                (imageIdentifierChange)="updateImageIdentifier(person, $event)"
                                                [imageWidth]="100"
                                                [defaultImageSrc]="defaultImageSrc"
                                                [disabled]="!isEditing"
                                                [inline]="true"
                                                class="profile-image-container profile-image-container-lg me-3"></adapt-select-image>
                        }
                        <div class="profile-name">
                            <span>{{ person.firstName }} {{ person.lastName }}</span>
                        </div>
                    </div>
                </adapt-dashboard-element>
                <adapt-person-profile-contacts [person]="person"
                                               [editMode]="isEditing"> </adapt-person-profile-contacts>
                @if (canReadLinks$ | async) {
                    <adapt-dashboard-element name="Links">
                        <a *adaptIfAuthorised="ReadCareerValuationForPerson; entity: person"
                           [routerLink]="cvtDashboardUrl$ | async"
                           data-test="career-valuation-pill-button"
                           class="me-2 mb-1 btn btn-primary btn-pill"> Career Valuation</a>
                        <a *adaptIfAuthorised="ReadCulturalIndexForPerson; entity: person"
                           [routerLink]="ciDashboardUrl$ | async"
                           class="me-2 mb-1 btn btn-primary btn-pill"> Cultural Index</a>
                        <a *adaptIfAuthorised="ReadPeerCatchUpForPerson; entity: person"
                           [routerLink]="pcuDashboardUrl$ | async"
                           data-test="peer-catch-up-pill-button"
                           class="me-2 mb-1 btn btn-primary btn-pill"> Peer Catch-ups</a>
                        <a *adaptIfAuthorised="ViewBoardForPerson; entity: person"
                           [routerLink]="kanbanDashboardUrl$ | async"
                           class="me-2 mb-1 btn btn-primary btn-pill"> Work</a>
                    </adapt-dashboard-element>
                }
                @if (latestConnection$ | async) {
                    <adapt-person-profile-access [person]="person"></adapt-person-profile-access>
                }
                @if (latestConnection$ | async) {
                    <adapt-person-profile-connection [person]="person"
                                                     [editMode]="isEditing"> </adapt-person-profile-connection>
                }
                @if (latestConnection$ | async; as latestConnection) {
                    @if (latestConnection.isEmployeeConnection()) {
                        <adapt-person-profile-position [person]="person"
                                                       [editMode]="isEditing"> </adapt-person-profile-position>
                    }
                }
                <adapt-person-profile-cultural-leader *adaptIfAuthorised="ReadCulturalLeadership"
                                                      [person]="person"
                                                      data-test="profile-cultural-leadership"> </adapt-person-profile-cultural-leader>
                <adapt-person-profile-roles [person]="person"
                                            [editMode]="isEditing"></adapt-person-profile-roles>
                <adapt-person-profile-teams [person]="person"></adapt-person-profile-teams>
                <adapt-person-profile-systems *adaptIfAuthorised="ReadSystem"
                                              [person]="person"></adapt-person-profile-systems>
            </div>
            <div right-column>
                <adapt-person-profile-items [person]="person"
                                            [editMode]="isEditing"> </adapt-person-profile-items>
            </div>
        </adapt-two-column-page>
    }
</ng-container>
